// extracted by mini-css-extract-plugin
export var card = "_qg-0";
export var content = "_qg-2";
export var details = "_qg-3";
export var icon = "_qg-1";
export var iconBlue = "_qg-5";
export var iconBrand = "_qg-4";
export var iconGrayBlue = "_qg-6";
export var iconGreen = "_qg-7";
export var iconIndigo = "_qg-8";
export var iconOrange = "_qg-9";
export var iconPurple = "_qg-a";
export var iconRed = "_qg-b";
export var iconWarning = "_qg-c";